import React, { useState } from 'react';
import './MenuSection.css';
import { useTranslation } from 'react-i18next';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Captions from 'yet-another-react-lightbox/plugins/captions';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

const MenuSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'en';

  const imageCount = 4;
  const menuImages = Array.from({ length: imageCount }, (_, i) => ({
    src: `/images/menus/menu-${i}-${lang}.jpg`,
    title: `${t('menu.page')} ${i + 1} / ${imageCount}`,
  }));

  const [lightboxOpen, setLightboxOpen] = useState(false);

  return (
    <section id="menu" className="menu-section">
      <h2>{t('menu.title')}</h2>
      {/* <p className="menu-description">{t('menu.description')}</p> */}

      <button
        className="menu-button"
        onClick={() => setLightboxOpen(true)}
        aria-label={t('menu.viewMenu')}
      >
        {t('menu.viewMenu')}
      </button>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={0}
        slides={menuImages}
        plugins={[Zoom, Captions, Thumbnails]}
        carousel={{ finite: true }}  // 🔒 Prevent looping
      />
    </section>
  );
};

export default MenuSection;
